import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";
import {
    PERFORMANCE_TRACKER_LIST, GET_PERFORMANCE_TRACKER_LIST, SEARCH_PERFORMANCE_TRACKER_BY_ID, PERFORMANCE_TRACKER_BY_ID,
    DELETE_PERFORMANCE_TRACKER, DELETE_PERFORMANCE_TRACKER_RESP, SAVE_PERFORMANCE_TRACKER, SAVE_PERFORMANCE_TRACKER_RESP,
    SEARCH_PERFORMANCE_TRACKER_BY_FIELD, PERFORMANCE_TRACKER_BY_FIELD_LIST
} from "./actionTypes";

export class GetPerformanceTrackerList implements Action {
    readonly type = GET_PERFORMANCE_TRACKER_LIST;
    readonly payload: any;
    constructor() {
    }
}

export class PerformanceTrackerList implements Action {
    readonly type = PERFORMANCE_TRACKER_LIST;
    readonly payload = []
    constructor(performaceTrackerList: Array<any>) {
        this.payload = performaceTrackerList;
    }
}

export class SearchPerformanceTrackerById implements Action {
    readonly type = SEARCH_PERFORMANCE_TRACKER_BY_ID;
    readonly payload: string = null;
    constructor(id) {
        this.payload = id
    }
}

export class PerformanceTrackerById implements Action {
    readonly type = PERFORMANCE_TRACKER_BY_ID;
    readonly payload = null;
    constructor(data) {
        this.payload = data
    }
}

export class SavePerformanceTracker implements Action {
    readonly type = SAVE_PERFORMANCE_TRACKER;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class SavePerformanceTrackerResp implements Action {
    readonly type = SAVE_PERFORMANCE_TRACKER_RESP;
    readonly payload = null;
    constructor(data: IServerResponse) {
        this.payload = data;
    }
}

export class DeletePerformanceTracker implements Action {
    readonly type = DELETE_PERFORMANCE_TRACKER;
    readonly payload = null;
    constructor(id) {
        this.payload = id;
    }
}

export class DeletePerformanceTrackerResp implements Action {
    readonly type = DELETE_PERFORMANCE_TRACKER_RESP;
    readonly payload = null;
    constructor(data: IServerResponse) {
        this.payload = data;
    }
}

export class SearchPerformanceTrackerByField implements Action {
    readonly type = SEARCH_PERFORMANCE_TRACKER_BY_FIELD;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export class PerformanceTrackerByFieldList implements Action {
    readonly type = PERFORMANCE_TRACKER_BY_FIELD_LIST;
    readonly payload = null;
    constructor(data) {
        this.payload = data;
    }
}

export type Actions = GetPerformanceTrackerList | PerformanceTrackerList | SearchPerformanceTrackerById | PerformanceTrackerById
    | SavePerformanceTracker | SavePerformanceTrackerResp | DeletePerformanceTracker | DeletePerformanceTrackerResp | SearchPerformanceTrackerByField | PerformanceTrackerByFieldList;
